import { Navigate, useNavigate } from "react-router-dom";

export const RequireAdmin = ({ children }) => {
  if (!localStorage.getItem("zentra-admin-token")) return <Navigate to="/admin" replace />;
  return children;
};

export const AdminShell = ({ title, children }) => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("zentra-admin-token");
    navigate("/admin");
  };
  return (
    <div className="min-h-screen bg-[#0A0A0A] px-5 py-8 lg:px-12" data-testid="admin-shell">
      <div className="mx-auto max-w-[1100px]">
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-white/10 pb-5">
          <div className="flex items-center gap-4">
            <img src="/assets/zentra-logo-white.png" alt="ZENTRA" className="h-8 w-auto" />
            <h1 className="font-display text-2xl uppercase tracking-wide text-white">{title}</h1>
          </div>
          <div className="flex items-center gap-4 text-xs font-medium uppercase tracking-[0.15em]">
            <a href="/admin/orders" data-testid="admin-nav-orders" className="text-white/60 transition-colors hover:text-[#7ED321]">Orders</a>
            <a href="/admin/products" data-testid="admin-nav-products" className="text-white/60 transition-colors hover:text-[#7ED321]">Products</a>
            <a href="/admin/settings" data-testid="admin-nav-settings" className="text-white/60 transition-colors hover:text-[#7ED321]">Settings</a>
            <button onClick={logout} data-testid="admin-logout-button" className="text-white/60 transition-colors hover:text-red-400">Logout</button>
          </div>
        </div>
        <div className="py-8">{children}</div>
      </div>
    </div>
  );
};
